import { useTranslation } from 'react-i18next';

type Props = {
  role: string;
};

export const formatRole = ({ role }: Props): string => {
  const { t } = useTranslation();

  switch (role.toUpperCase()) {
    case 'CLIENT':
      return t('General.Role.Client');
    case 'SHIPPER':
      return t('General.Role.Shipper');
    case 'SHIPPER_MANAGER':
      return t('General.Role.ShipperManager');
    case 'AGENCY_DIRECTOR':
      return t('General.Role.AgencyDirector');
    case 'SHIPPER_DIRECTOR':
      return t('General.Role.ShipperDirector');
    case 'ADMIN':
      return t('General.Role.Admin');
    default:
      return 'Autre';
  }
};
